import React from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./MeetingPerson.css";

function MeetingPerson({
  id,
  firstName,
  lastName,
  profileName,
  profileNameEnglish,
  language,
}) {
  const navigate = useNavigate();

  return (
    <Row className="meeting-person align-items-center">
      <Col className="meeting-person-header">
        <h5 onClick={() => navigate(`/mymeetings/person/${id}`)}>
          {firstName} {lastName}
        </h5>
        <p>{language === "es" ? profileName : profileNameEnglish}</p>
      </Col>
    </Row>
  );
}

export default MeetingPerson;
